<script setup>
import {computed, watch} from 'vue'
import {useFormStore} from '@/stores/form'
import vFormValidation from '@/vue/directives/formValidation' // Prefix with 'v' for auto-registration
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

// Pinia Store
const formStore = useFormStore(props.formId)

const step = computed(() => parseFloat(props.field.step || '60'))

watch(() => props.value, (newVal) => {
    if (!newVal) return

    // If step is 60+, strip seconds and ms to force Chrome to hide those fields.
    if (step.value >= 60) {
        props.currentData[props.field.name] = newVal.split(':').slice(0, 2).join(':')
        return
    }

    // If step is 1-59, strip ms but keep seconds
    if (step.value >= 1) {
        props.currentData[props.field.name] = newVal.split('.')[0]
        return
    }

    // If step is < 1, return the full value for ms support
    props.currentData[props.field.name] = newVal
}, {immediate: true})

formStore.setDefaultValue({
    name: props.field.name,
    value: ''
})
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <input v-else
           :id="field.id"
           v-model="currentData[field.name]"
           v-select="field.autofocus"
           v-form-validation
           :disabled="field.disabled"
           :max="field.max"
           :min="field.min"
           :name="field.name"
           :required="field.required"
           :step="step"
           autocomplete="off"
           class="form-control"
           :class="{'is-invalid': field.error}"
           type="time">
</template>